import {Component, OnInit} from '@angular/core';
import {environment} from "../../../environments/environment";
import {ActivatedRoute, Router} from "@angular/router";
import {MessageService} from "primeng/api";
import {StudiosService} from "../../studios/studios.service";
import {HelperService} from "../../common/helper.service";
import {ProfileService} from "../../common/profile.service";
import {map} from "rxjs/operators";
import {UserService} from "../../users/user/user.service";
import {InstrumentAndEquipmentService} from "../../common/instruments.equipments.service";

@Component({
  selector: 'app-wizard-studio-rentals',
  templateUrl: './wizard-studio-rentals.component.html',
  styleUrls: ['./wizard-studio-rentals.component.scss']
})
export class WizardStudioRentalsComponent  implements OnInit {

  private userId;
  private studioId;

  public studio;
  studioEquipment: any;

  instruments;
  equipments;
  instrumentBrandMap = new Map<String, any[]>();
  equipmentBrandMap = new Map<String, any[]>();

  newInstrument;
  newInstrumentBrand;
  newInstrumentName;
  newInstrumentPrice;
  newInstrumentAvailability = true;

  public businessCurrency: string;

  env = environment;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
    private studiosService: StudiosService,
    private userService: UserService,
    private profileService: ProfileService,
    private instrumentAndEquipmentService: InstrumentAndEquipmentService,
  ) {
    this.userId = this.profileService.getUserData().id;
    this.studio = this.studiosService.studio$;
    this.businessCurrency = this.profileService.getOwnerStudio().businessCurrency ? this.profileService.getOwnerStudio().businessCurrency : 'EUR';

    this.studioEquipment = this.studiosService.rentalEquipment$.pipe(
      map((equipments) => {
        return equipments.map(eq => {
          eq.editAvailable = eq.available;
          return eq;
        });
      })
    );
  }

  ngOnInit(): void {
    this.instruments = this.instrumentAndEquipmentService.instruments;
    this.equipments = this.instrumentAndEquipmentService.equipments;

    this.instruments.forEach(inst => {
      this.instrumentBrandMap.set(inst.type, inst.brands);
    });
    this.equipments.forEach(eq => {
      this.equipmentBrandMap.set(eq.type, eq.brands);
    });

    this.studioId = this.profileService.getOwnerStudio().id;
    this.studiosService.fetchStudio(this.studioId, true)
      .then((studioData) => {
      });

    this.studiosService.fetchStudioRentalEquipment(this.studioId);

  }


  resetNewInstrumentBrand(){
    if (!this.newInstrument?.brands.some(brand => brand.type === this.newInstrumentBrand?.type)){
      this.newInstrumentBrand = null;
    }
  }

  addNewInstrument() {
    const newInstrument: any = {};
    newInstrument.name = this.newInstrumentName;
    newInstrument.category = this.newInstrument?.type;
    newInstrument.price = this.newInstrumentPrice;
    newInstrument.available = this.newInstrumentAvailability;
    newInstrument.brand = this.newInstrumentBrand?.type;
    if (!newInstrument.category) {
      this.messageService.add({
        key: 'globalToast', severity: 'error', summary: 'Error', detail: 'Instrument Type is required!', life: 3000});
    } else if (!newInstrument.brand) {
      this.messageService.add({
        key: 'globalToast', severity: 'error', summary: 'Error', detail: 'Instrument Brand is required!', life: 3000});
    } else if (!newInstrument.name) {
      this.messageService.add({
        key: 'globalToast', severity: 'error', summary: 'Error', detail: 'Instrument Name is required!', life: 3000});
    } else if (!newInstrument.price && newInstrument.price !== 0) {
      this.messageService.add({
        key: 'globalToast', severity: 'error', summary: 'Error', detail: 'Instrument Price is required!', life: 3000});
    } else {
      this.studiosService.createInstrument(this.studioId , newInstrument)
        .then((data) => {
          this.newInstrumentPrice = null;
          this.newInstrument = null;
          this.newInstrumentName = null;
          this.newInstrumentBrand = null;
          this.newInstrumentAvailability = true;
          this.messageService.add({
            key: 'globalToast', severity: 'success', summary: 'Successful', detail: 'Instrument Added', life: 3000});
        });
    }

  }

  previousPage() {
    this.router.navigate(['studio-rooms'], { relativeTo: this.route.parent });
  }

  nextPage( skip = false) {
    if (skip) {
      this.router.navigate(['dashboard/partner']);
    } else {
      this.userService.removeRegistrationByType(this.userId, 'partner_wizard')
        .then((data) => {
          this.router.navigate(['dashboard/partner']);
        });
    }
  }
}
